import { ElementType } from 'react'

import { FormSchemaValue } from '../schema/input'

type Props = {
  city?: string
  dir: string
  document: ElementType
  hasExpirationDate: boolean
  value: FormSchemaValue
}

export const StepDocuments = ({
  city,
  dir,
  document: Document,
  hasExpirationDate,
  value,
}: Props) => (
  <Document
    city={city}
    dir={dir}
    hasExpirationDate={hasExpirationDate}
    value={value}
  />
)
